function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import config from 'react-global-configuration';
import queryString from 'query-string';
import './style.scss';
import classNames from 'classnames';
import { Icon } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
function getNodeUrls(node, entityType, permissions, t) {
  var urls = [];
  var nodeId = node.getIn(['nid', 0, 'value']);
  var nodeType = node.getIn(['type', 0, 'target_id'], null);
  var nodeUserId = node.getIn(['uid', 0, 'target_id'], null);
  var edit = {
    title: t('contextual_links.node.edit', 'Edit node'),
    url: "/node/".concat(nodeId, "/edit")
  };
  var remove = {
    title: t('contextual_links.node.delete', 'Delete node'),
    url: "/node/".concat(nodeId, "/delete")
  };
  if (permissions.includes('administer nodes') || permissions.includes("edit any ".concat(nodeType, " content")) || permissions.includes("edit own ".concat(nodeType, " content")) && isCurrentUserId(nodeUserId)) {
    urls.push(edit);
  }
  if (permissions.includes('administer nodes') || permissions.includes("delete any ".concat(nodeType, " content")) || permissions.includes("delete own ".concat(nodeType, " content")) && isCurrentUserId(nodeUserId)) {
    urls.push(remove);
  }
  return urls;
}
function getUserUrls(user, entityType, permissions, t) {
  var urls = [];
  var userId = user.get('id');
  var edit = {
    title: t('contextual_links.user.edit', 'Edit user'),
    url: "/node/".concat(userId, "/edit")
  };
  if (permissions.includes('administer users')) {
    urls.push(edit);
  }
  return urls;
}
function getTaxonomyUrls(taxonomyTerm, entityType, permissions, t) {
  var urls = [];
  var taxonomyTermId = taxonomyTerm.getIn(['tid', 0, 'value']);
  var edit = {
    title: t('contextual_links.taxonomy_term.edit', 'Edit term'),
    url: "/taxonomy/term/".concat(taxonomyTermId, "/edit")
  };
  var remove = {
    title: t('contextual_links.taxonomy_term.delete', 'Delete term'),
    url: "/taxonomy/term/".concat(taxonomyTermId, "/delete")
  };
  if (permissions.includes('administer taxonomy')) {
    urls.push(edit);
    urls.push(remove);
  }
  return urls;
}
function getParagraphUrls(paragraph, entityType, permissions, t) {
  var urls = [];
  var paragraphId = paragraph.getIn(['id', 0, 'value']);
  var parentEntityId = useSelector(function (state) {
    return state.getIn(['entity', 'entityId'], null);
  });
  var parentEntityType = useSelector(function (state) {
    return state.getIn(['entity', 'entityType'], null);
  });
  var parentUserId = useSelector(function (state) {
    return state.getIn([parentEntityType, parentEntityId, 'uid', 0, 'target_id'], null);
  });
  var parentEntityBundle = useSelector(function (state) {
    return state.getIn([parentEntityType, parentEntityId, 'type', 0, 'target_id']);
  });
  var edit = {
    title: t('contextual_links.paragraph.edit', 'Edit paragraph'),
    url: "/paragraphs_edit/".concat(parentEntityType, "/").concat(parentEntityId, "/paragraphs/").concat(paragraphId, "/edit")
  };
  var remove = {
    title: t('contextual_links.paragraph.delete', 'Delete paragraph'),
    url: "/paragraphs_edit/".concat(parentEntityType, "/").concat(parentEntityId, "/paragraphs/").concat(paragraphId, "/delete")
  };
  var clone = {
    title: t('contextual_links.paragraph.clone', 'Clone paragraph'),
    url: "/paragraphs_edit/".concat(parentEntityType, "/").concat(parentEntityId, "/paragraphs/").concat(paragraphId, "/clone")
  };
  if (parentEntityId !== null && parentEntityType !== null) {
    if (permissions.includes("administer ".concat(parentEntityType, " fields")) || permissions.includes("edit any ".concat(parentEntityBundle, " content")) || permissions.includes("edit own ".concat(parentEntityBundle, " content")) && isCurrentUserId(parentUserId)) {
      urls.push(edit);
    }
    if (permissions.includes("administer ".concat(parentEntityType, " fields")) || permissions.includes("delete any ".concat(parentEntityBundle, " content")) || permissions.includes("delete own ".concat(parentEntityBundle, " content")) && isCurrentUserId(parentUserId)) {
      urls.push(remove);
    }
    if (permissions.includes("administer ".concat(parentEntityType, " fields")) || permissions.includes("create ".concat(parentEntityBundle, " content"))) {
      urls.push(clone);
    }
  }
  return urls;
}
function getWebformUrls(webform, entityType, permissions, t) {
  var urls = [];
  var webformId = webform.id;
  var webformUserId = useSelector(function (state) {
    return state.getIn(['webform', webformId, 'uid', 0, 'target_id'], null);
  });
  var edit = {
    title: t('contextual_links.webform.edit', 'Edit webform'),
    url: "/admin/structure/webform/manage/".concat(webformId, "/settings")
  };
  var submissions = {
    title: t('contextual_links.webform.submissions', 'Show submissions'),
    url: "/admin/structure/webform/manage/".concat(webformId, "/results/submissions")
  };
  if (permissions.includes('administer webform') || permissions.includes('edit any webform') || permissions.includes('edit own webform') && isCurrentUserId(webformUserId)) {
    urls.push(edit);
  }
  if (permissions.includes('administer webform') || permissions.includes('view any webform submission')) {
    urls.push(submissions);
  }
  return urls;
}
function getMediaUrls(media, entityType, permissions, t) {
  var urls = [];
  var mediaUserId = media.getIn(['entity', 'uid', 0, 'target_id']);
  var mediaType = media.get('target_type');
  var edit = {
    title: t('contextual_links.media.edit', 'Edit media'),
    url: "".concat(media.get('url'))
  };
  var remove = {
    title: t('contextual_links.media.delete', 'Delete media'),
    url: "/media/".concat(media.get('target_id'), "/delete")
  };
  if (permissions.includes('administer media') || permissions.includes("edit any ".concat(mediaType, " media")) || permissions.includes("edit own ".concat(mediaType, " media")) && isCurrentUserId(mediaUserId)) {
    urls.push(edit);
  }
  if (permissions.includes('administer media') || permissions.includes("delete any ".concat(mediaType, " media")) || permissions.includes("delete own ".concat(mediaType, " media")) && isCurrentUserId(mediaUserId)) {
    urls.push(remove);
  }
  return urls;
}
function getMenuUrls(menu, entityType, permissions, t) {
  var urls = [];
  var edit = {
    title: t('contextual_links.menu.edit', 'Edit menu'),
    url: "/admin/structure/menu/manage/".concat(menu.id)
  };
  if (permissions.includes('administer menu')) {
    urls.push(edit);
  }
  return urls;
}
function isCurrentUserId(userId) {
  return useSelector(function (state) {
    return state.getIn(['user', userId], false);
  });
}
var ContextualActionsButtons = function ContextualActionsButtons(_ref) {
  var entityType = _ref.entityType,
    entity = _ref.entity,
    children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var permissions = useSelector(function (state) {
    return state.getIn(['ui', 'permissions']);
  });
  var editUrls = [];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showButtons = _useState2[0],
    setShowButtons = _useState2[1];
  var API_URL = config.get('API_URL');
  function toggleEditButtons() {
    setShowButtons(!showButtons);
  }
  function hideEditButtons() {
    setShowButtons(false);
  }
  switch (entityType) {
    case 'node':
      editUrls = getNodeUrls(entity, entityType, permissions, t);
      break;
    case 'user':
      editUrls = getUserUrls(entity, entityType, permissions, t);
      break;
    case 'taxonomy_term':
      editUrls = getTaxonomyUrls(entity, entityType, permissions, t);
      break;
    case 'paragraph':
      editUrls = getParagraphUrls(entity, entityType, permissions, t);
      break;
    case 'webform':
      editUrls = getWebformUrls(entity, entityType, permissions, t);
      break;
    case 'media':
      editUrls = getMediaUrls(entity, entityType, permissions, t);
      break;
    case 'menu':
      editUrls = getMenuUrls(entity, entityType, permissions, t);
      break;
    default:
      break;
  }
  if (!editUrls.length) {
    return children;
  }
  var classes_actions = classNames('ContextualActionsButtons__actions', "ContextualActionsButtons__actions--".concat(entityType), {
    'ContextualActionsButtons__actions--active': showButtons
  });
  return /*#__PURE__*/React.createElement("div", {
    className: 'ContextualActionsButtons ContextualActionsButtons--' + entityType,
    onMouseLeave: hideEditButtons
  }, /*#__PURE__*/React.createElement("div", {
    className: classes_actions
  }, /*#__PURE__*/React.createElement("a", {
    onClick: toggleEditButtons
  }, /*#__PURE__*/React.createElement(Icon, {
    flair: "filled",
    name: "edit"
  })), /*#__PURE__*/React.createElement("div", {
    className: "ContextualActionsButtons__links"
  }, editUrls.map(function (item, index) {
    return /*#__PURE__*/React.createElement("a", {
      key: index,
      href: queryString.stringifyUrl({
        url: API_URL + item.url,
        query: {
          destination: window.location.pathname
        }
      })
    }, item.title);
  }))), children);
};
export default ContextualActionsButtons;